import React, { useState } from "react";
import { ImPointRight } from "react-icons/im";
import {GrLike} from "react-icons/gr"
import {BsHeartFill} from "react-icons/bs"
import {AiFillGithub} from "react-icons/ai"


const Card = (props) => {
  const [modal, setModal] = useState(false);

  const [like, setLike] = useState(true);

  const handleLike = () => {
    setLike(!like)
  }


  const toggleModal = () => {
    setModal(!modal);
  };

  if (modal) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }
  return (
    <>
      <div className="box btn_shadow ">
        <div className="img">
          <img src={props.image} alt="" onClick={toggleModal} />
        </div>
        <div className="category d_flex extra">
          <span onClick={toggleModal}>{props.category}</span>
          <div className="likes">
           <BsHeartFill color="red"/> {props.totalLike}
          </div>
        </div>
        <div className="title">
          <h2 onClick={toggleModal}>{props.title}</h2>
          <a href="#popup" className="arrow" onClick={toggleModal}>
            <i class="fas fa-arrow-right"></i>
          </a>
          <a href={props.github} target={"_blank"}><AiFillGithub/></a>
        </div>
      </div>

      {/* Popup box */}
      {modal && (
        <div className="modal">
          <div onClick={toggleModal} className="overlay"></div>
          <div className="modal-content d_flex">
            <div className="modal-img left">
              <img src={props.image} alt="" />
            </div>
            <div className="modal-text right">
              <span>React</span>
              <h1>{props.title}</h1>
              <p class="overview">{props.overview}</p>
              <p>{props.desc}</p>
              <div className="button f_flex mtop">
                {like ? 
                ( <button className= "btn_shadow more_btn_css" onClick={handleLike} style={{backgroundColor:"#488cf1"}}>
                  <div style={{display:'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                  LIKED THIS <span><GrLike/></span>
                  </div>
                </button>) : 
                ( <button className= "btn_shadow more_btn_css" onClick={handleLike}>
                  <div style={{display:'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                  LIKE THIS <span><GrLike/></span>
                  </div>
                </button>)}
               
                <a href={props.deployed_link} target="_blank" rel="noreferrer">
                  <button className="btn_shadow more_btn_css">
                  <div style={{display:'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    VIEW PROJECT <span><ImPointRight/></span>
                  </div>
                </button>
                </a>
                
              </div>
              <button className="close-modal" onClick={toggleModal}>
                <i class="fas fa-times">x</i>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Card;
